import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2cd5d46c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "form" };
const _hoisted_2 = ["readonly"];
import { useTextareaAutosize } from "@vueuse/core";
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TextareaAutosize',
    props: {
        modelValue: {},
        readonly: { type: Boolean, default: false }
    },
    emits: ["update:modelValue", "blur"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const valueProxy = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const relayBlurEvent = (event) => {
            emit("blur", event);
        };
        const el = ref();
        const { textarea, input } = useTextareaAutosize({
            element: el,
            input: valueProxy,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _withDirectives(_createElementVNode("textarea", {
                    class: "resize-none",
                    ref_key: "el",
                    ref: el,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event)),
                    onBlur: relayBlurEvent,
                    readonly: _ctx.readonly
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
                    [_vModelText, valueProxy.value]
                ])
            ]));
        };
    }
});
